import axios from "axios";

export default class InventoryApiClient {
  constructor(User, AuthorizationHeader) {
    // this.scope = CXMStores.map(store => store.AccountPlatformID)
    //     : [];
    this.headers = {
      "Content-Type": "application/json",
      Accept: "application/json",
      Authorization: AuthorizationHeader,
    };
  }

  formatRequestUrl(requestUrl) {
    if (requestUrl && !requestUrl.startsWith("/"))
      requestUrl = `/${requestUrl}`;

    return process.env.INVENTORY_API_URL + requestUrl;
  }

  ProcessRequest(type, url, payload, params, responseType, withCredentials) {
    // this.headers.Scope = JSON.stringify(
    //   scope && scope.length > 0 ? scope : this.scope
    // );
      return axios({
      method: type,
      url: this.formatRequestUrl(url),
      params: params,
      data: payload,
      headers: this.headers,
      responseType: responseType || "json",
      withCredentials: withCredentials ? withCredentials : false
    });
  }
}



// WEBPACK FOOTER //
// ./src/api/InventoryApiClient.js